var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWave6 = function SvgWave6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1440 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB81C",
    d: "M0 100V0c265.5 127 1038.5 100 1440 19.5V100z"
  })));
};
export default SvgWave6;